import React, { useState, useRef, useEffect } from 'react';
import { func } from 'prop-types';
import { isAndroidApp } from '../../../core/util/device';

const FileUpload = props => {
  const [capturedEvent, setCapturedEvent] = useState(null);
  const [responseReceived, setResponseReceived] = useState(false);
  const inputRef = useRef();

  const handleRequestPermissionsResponse = () => setResponseReceived(true);

  const handleClick = event => {
    const { nativeEvent } = event;

    if (isAndroidApp() && !nativeEvent.recaptured) {
      const clonedEvent = new MouseEvent('click', nativeEvent);
      clonedEvent.recaptured = true;
      setCapturedEvent(clonedEvent);

      event.stopPropagation();
      event.preventDefault();

      window.requestCameraPermissions && window.requestCameraPermissions();
    } else props.onClick && props.onClick(event);
  };

  useEffect(() => {
    document.addEventListener('message', handleRequestPermissionsResponse);
    return () => document.removeEventListener('message', handleRequestPermissionsResponse);
  }, []);

  useEffect(() => {
    if (responseReceived && capturedEvent) {
      inputRef.current.dispatchEvent(capturedEvent);
      props.onClick && props.onClick(capturedEvent);
    }
  }, [capturedEvent, responseReceived]);

  return <input {...props} ref={inputRef} onClick={handleClick} />;
};

FileUpload.propTypes = { onClick: func };

export default FileUpload;
